import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeDeleteSmartSearchFeedbackResponse } from '~/types/smart-search.types';

/**
 * [스마트검색] 피드백 취소 API
 */
const fetchDeleteSmartSearchFeedback = async (queryId: string): Promise<null> => {
  const { data } = await axiosInstance.delete<TypeDeleteSmartSearchFeedbackResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.POST_SMART_SEARCH_FEEDBACK}/${queryId}/feedback`
  );
  return data.data;
};

/**
 * [스마트검색] 피드백 취소 Mutation Hook
 * - 사용자가 선택한 피드백을 다시 클릭해서 해제할 때 호출
 */
export const useDeleteSmartSearchFeedback = () => {
  return useMutation({
    mutationFn: fetchDeleteSmartSearchFeedback,
    meta: { showGlobalLoading: false },
  });
};

registerMockAPI({
  method: 'delete',
  endpoint: '/api-delivery-agency/smart-search/:queryId/feedback',
  label: '배송/스마트검색/피드백 취소',
  scenarios: [
    {
      name: '정상 응답',
      response: { data: null },
    },
    {
      name: '서버 오류 (60500)',
      response: { error: { code: 60500, message: '서버에서 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
